var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 36H29.3333M21 36C21 44.2843 27.7157 51 36 51M21 36C21 27.7157 27.7157 21 36 21M29.3333 36H42.6667M29.3333 36C29.3333 44.2843 32.3181 51 36 51M29.3333 36C29.3333 27.7157 32.3181 21 36 21M42.6667 36H51M42.6667 36C42.6667 27.7157 39.6819 21 36 21M42.6667 36C42.6667 44.2843 39.6819 51 36 51M51 36C51 27.7157 44.2843 21 36 21M51 36C51 44.2843 44.2843 51 36 51",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/globalIcon.e2b892c2213b49c15a261e0d518a2766.svg";
export { ForwardRef as ReactComponent };